import { gql } from "@apollo/client";

export const QUERY_CASE_TRACKER_CASES = gql`
  query CaseTrackerCases(
    $states: [CaseState!]
    $search: String
    $sortBy: CaseTrackerSort
    $sortDirection: SortDirection
    $offset: Int
    $limit: Int
  ) {
    caseTracker {
      cases(
        states: $states
        search: $search
        sortBy: $sortBy
        sortDirection: $sortDirection
        pagination: { offset: $offset, limit: $limit }
      ) {
        totalCount
        results {
          uuid
          reference
          brokerName
          brokerReference
          applicantOneName
          applicantTwoName
          applicantOneOpenBankingLinked
          applicantTwoOpenBankingLinked
          postcode
          loanAmount
          openTaskCount
        }
      }
    }
  }
`;

export const QUERY_CASE_TRACKER_SUMMARY = gql`
  query CaseTrackerSummary($search: String) {
    caseTracker {
      summary(search: $search) {
        state
        caseCount
        openTaskCount
      }
    }
  }
`;

// The tracker is the only place the backend exposes applicants' open banking status.
export const QUERY_CASE_OPEN_BANKING = gql`
  query CaseOpenBanking($search: String!) {
    caseTracker {
      cases(search: $search, pagination: { offset: 0, limit: 20 }) {
        results {
          uuid
          applicantOneOpenBankingLinked
          applicantTwoOpenBankingLinked
        }
      }
    }
  }
`;
